/**
 * Admin Users page component.
 *
 * Main page for user management in the admin panel.
 * Displays the UserManager component for user account management.
 *
 * Route: `/admin/users`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminUsersPage
 */

import UserManager from '@/components/admin/UserManager';

export default function AdminUsersPage() {
  return <UserManager />;
}
